import * as angular from "angular";
import * as _ from "lodash";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";
import {TaskModel} from "../models/task.model";
import {ActionReasonModel} from "../../action-reasons/models/action-reason.model";

export class TaskRequests {

  /* @ngInject */
  constructor(private tasksAPI: BringozApi, private $task) {
  }

  // ******************************
  // External methods
  // ******************************

  changeTaskStatus(status, task) {
    const api = _.get(this.tasksAPI, 'actions.changeStatus_' + status);
    return this.$$call(api, {ids: task.id}, task, {});
  }

  changeTaskStatusToCancel(cancellationReason, taskId, relatedServiceIds?: string[]) {
    const api = this.tasksAPI.actions.cancelTask;
    return this.$$call(api, {taskId: taskId, relatedServiceIds: relatedServiceIds}, cancellationReason, {});
  }

  //start or end task
  updateInternalTask(task: TaskModel) {
    const api = this.tasksAPI.actions.updateInternalTask;
    return this.$$call(api, {}, {
      notBefore: _.get(task, 'taskSpec.notBefore'),
      notAfter: _.get(task, 'taskSpec.notAfter'),
      subTasks: _.get(task, 'subTasks')
    }, {id: task.id});
  }

  getOfflineActions(taskIds: string[]) {
    const api = this.tasksAPI.actions.getOfflineActions;
    return this.$$call(api, {taskId: taskIds}, {}, {});
  }

  editTaskServiceTime(taskId: string, payload: {
    detailedServiceTime?: any,
    legacyServiceTime?: number,
    useLegacyServiceTime: boolean
  }) {
    const api = this.tasksAPI.actions.editTaskServiceTime;
    return this.$$call(api, {}, payload, {taskId: taskId});
  }

  editTaskExtraInfo(taskId: string, extraInfo: string) {
    const api = this.tasksAPI.actions.editTaskExtraInfo;
    return this.$$call(api, {}, extraInfo, {taskId: taskId});
  }

  revertTaskStatus(taskId: string, revertReason: ActionReasonModel) {
    const api = this.tasksAPI.actions.revertTaskStatus;
    return this.$$call(api, {}, revertReason, {taskId: taskId});
  }

  // ******************************
  // Internal methods
  // ******************************

  $$call(_apiCall, _params, _data, _options, taskId ?) {
    return this.$task(taskId).$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.tasks')
  .service('taskRequests', TaskRequests);
